import { Badge } from '@/components/ui/badge'
import { m } from '@/lib/paraglide/messages'
import { formatCountdown, getSLAState } from '@/lib/sla-utils'

interface Props {
    deadlineAt?: string
    breached: boolean
    warningAt?: string
}

export function SLABadge({ deadlineAt, breached, warningAt }: Props) {
    const state = getSLAState(deadlineAt, breached, warningAt)

    if (state === 'none') return null

    // Traffic-light đồng bộ bảng màu mới (nền nhạt + chữ đậm cùng tông, tương phản
    // AA↑, có bản dark): quá hạn = đỏ, sắp trễ = hổ phách, còn hạn = xanh lá.
    if (state === 'breached') {
        return (
            <Badge className="bg-red-100 text-red-800 dark:bg-red-900/40 dark:text-red-200">
                {m.sla_overdue()}
            </Badge>
        )
    }

    const countdown = deadlineAt ? formatCountdown(deadlineAt) : ''
    if (state === 'warning') {
        return (
            <Badge className="bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-200">
                {countdown
                    ? `${m.sla_almost_overdue()} · ${countdown}`
                    : m.sla_almost_overdue()}
            </Badge>
        )
    }
    return (
        <Badge className="bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200">
            {countdown ? `${countdown} ${m.sla_remaining()}` : m.sla_deadline()}
        </Badge>
    )
}
